import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, CSP_NONCE, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";
import { ModalModule } from 'ngx-bootstrap/modal';

import { AppInitializerService, GspComponentsModule, GspGuardsModule, GspInterceptorsModule, GspMaterialModule, GspPipesModule, GspServicesModule, GspSharedModule, HeaderFactoryService, PipeLineErrorService } from 'common';

import {
  AdapterModule, AppLoadService,
  ADPComponentsModule as ComponentsModule,
  ADPServicesModule as ServicesModule
} from 'digital-core';

import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ResolversModule } from 'common/modules/gsp-resolvers.module';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DealerShipDetailService } from './services/dealership-detail.service';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';

export function get_resources(appInitializerService:AppInitializerService) {
  
  return () => appInitializerService.getConfig();
}
@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    ServicesModule.forRoot(environment),
    GspServicesModule.forRoot(environment),
    ModalModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    GspGuardsModule,
    ResolversModule,
     NgxMaskPipe,
     NgxMaskDirective,
    GspInterceptorsModule, ComponentsModule,GspComponentsModule,AdapterModule,GspMaterialModule,GspPipesModule,GspSharedModule
  ],
  providers: [{
    provide: MatDialogRef,
    useValue: {}
  },
  { provide: Window, useValue: window },
  {
    provide: MAT_DIALOG_DATA,
    useValue: {}
  },
  provideNgxMask(),
  {
    provide: STEPPER_GLOBAL_OPTIONS,
    useValue: { displayDefaultIndicatorType: false }
  },
  {
    provide: APP_INITIALIZER,
    useFactory: get_resources,
    deps: [AppInitializerService, AppLoadService, PipeLineErrorService],
    multi: true
},
{
    provide: CSP_NONCE,
     useFactory: (headerFactoryService:HeaderFactoryService) =>{
         return headerFactoryService.getRandomSecret();;
      },
    deps: [HeaderFactoryService]
  }, DealerShipDetailService],

  bootstrap: [AppComponent]
})
export class AppModule { }
